module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h2', {
    staticClass: "Verse-head",
    attrs: {
      "id": "_idParaDest-14"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor014"
    }
  }), _vm._v("Cruciform")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Rooted tree")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("reaching up to heaven")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("branches tendered wide")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("sheltering, budding, laden.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Is this you?")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Welling energies of love")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("all held together ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("in one upright man")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("albeit touched ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("by every open")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("and unhealed wound.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Crosspiece:")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("shackled arms, hands,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("reach out")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("with fiery gifts")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("of love embracing")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("each and every crushed")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("forsaken soul.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Streams ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("of bloodied life")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("lovely as a rainbow")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("now hit the ground")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("easing earth’s pain")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("flowing on")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("to fished-out oceans")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("stitching up ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("the tattered robes")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("of a once-splendid")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("mothered earth.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("All givens ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("of a hospitality")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("we once knew")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36b22e18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398400801_EPUB-16.vue
// module id = 105
// module chunks = 0